import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { extractClientMatterNumbers } from '@repo/utils/clientMatterNumbers'

const initialState = {
  fetchedWorkflowStatus: '',
  fetchedWorkflowStatusPermissions: {},
  clientMatterNo: null
}

export const useWorkflowStatusStore = storeWrapper('useWorkflowStatusStore', (set) => ({
  ...initialState,
  fetchWorkflowStatus: async ({ clientMatterNo }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchWorkflowStatus_${clientMatterNo}`,
        delay: 500,
        callback: async () => {
          const { clientNo, matterNo } = extractClientMatterNumbers({ clientMatterNo })

          let fetchedWorkflowStatus

          try {
            fetchedWorkflowStatus =
              (await ospreyAPI({
                service: 'matters',
                endpoint: 'Matter/GetWorkflowStatus',
                data: { clientNo: clientNo, matterNo: matterNo }
              })) || ''
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ fetchedWorkflowStatus: fetchedWorkflowStatus })
          resolve(fetchedWorkflowStatus)
        }
      })
    })
  },
  updateWorkflowStatus: async ({ clientMatterNo, workflowStatus, successToastMessage }) => {
    const { clientNo, matterNo } = extractClientMatterNumbers({ clientMatterNo })

    const data = { clientNo: clientNo, matterNo: matterNo, workflowStatus: workflowStatus }

    await ospreyAPI({
      service: 'matters',
      endpoint: 'Matter/UpdateWorkflowStatus',
      method: 'PUT',
      data: data,
      sendAsUrlParams: true,
      successToast: successToastMessage
        ? {
            type: 'success',
            title: `Workflow Status updated`,
            text: successToastMessage,
            clientMatterNo
          }
        : null
    })
  },
  fetchWorkflowStatusPermissions: async ({ clientMatterNo }) => {
    const { clientNo, matterNo } = extractClientMatterNumbers({ clientMatterNo })

    let fetchedWorkflowStatusPermissions

    try {
      fetchedWorkflowStatusPermissions =
        (await ospreyAPI({
          service: 'matters',
          endpoint: 'Matter/GetWorkflowStatusPermissions',
          data: { clientNo: clientNo, matterNo: matterNo }
        })) || {}
    } catch (err) {
      console.log('Error:', err)
      return
    }

    set({ fetchedWorkflowStatusPermissions: fetchedWorkflowStatusPermissions })
  },
  reset: () => set(initialState)
}))
